import type { DurableWriteFn } from "@heraion/ui";

import { apiFetch } from "./api";

// THE web half of the durable-write seam (`@heraion/ui` seams.ts).
//
// Web has no offline queue, and the seam's own doc comment forbids faking
// one: this NEVER answers `queued`, only `sent` or `rejected`. `apiFetch`
// stamps its own Idempotency-Key per call since web never retries a write
// behind the caller's back. With no queue, `ifMatch` (S5, #336) always
// rides the one send.
export const durableWrite: DurableWriteFn = async (op) => {
  try {
    await apiFetch(op.path, {
      method: op.method,
      ...(op.body === undefined ? {} : { body: op.body }),
      ...(op.ifMatch === undefined ? {} : { headers: { "If-Match": op.ifMatch } }),
      ...(op.onEtag === undefined ? {} : { onEtag: op.onEtag }),
    });
    return { outcome: "sent" };
  } catch (error) {
    return { outcome: "rejected", error };
  }
};
